export const CBottomFooterLinks = {
  field: `
      fragment bottomFooterLinks on bottomFooterLinks_MatrixField {
        ... on bottomFooterLinks_links_BlockType {
          id
          linkName
          linkUrl
          linkPosition
        }
      }
    `,
}
